<template>
    <div>
        <el-dialog
            :title="type == 1 ? $t('invoicesCenter.endpackDialogtitlecompleteaccept') : $t('invoicesCenter.endpackDialogtitlecompletepick')"
            :visible.sync="dialogVisible"
            width="800px"
            @close="close"
            append-to-body
        >
            <div>
                <div style="width: 100%; text-align: center ; font-size: 16px; color: #333; text-align: center">
                  {{ $t('invoicesCenter.endpackWarningmessage') }}
                </div>
                <div
                    style="
                        width: 100%;
                        text-align: center;
                        /*margin-left: 200px;*/
                        height: 20px;
                        margin-top: 30px;
                        font-size: 16px;
                        color: #333;
                        text-align: center;
                    "
                >
                    <span>{{ $t('invoicesCenter.endpackTotalquantityV1') }}{{ modalParams.distriNumTotal }}</span>
                    <span style="margin: 0 30px"
                        >{{ type == 1 ? $t('invoicesCenter.endpackAcceptedquantity') : $t('invoicesCenter.endpackPickedquantity') }}{{ modalParams.receiveNumTotal }}</span
                    >
                    <span style="color: #f8475f;margin: 0 30px " v-if="modalParams.excessReceiveNumTotal > 0"
                        >{{ type == 1 ? $t('invoicesCenter.endpackExcessacceptedquantity') : $t('invoicesCenter.endpackExcesspickedquantity') }}{{ Math.abs(modalParams.excessReceiveNumTotal) }}</span
                    >
                    <span style="color: #f8475f; margin: 0 30px" 
                        >{{ type == 1 ? $t('invoicesCenter.endpackUnacceptedquantity') : $t('invoicesCenter.endpackUnpickedquantity') }}{{ modalParams.noReceiveNumTotal }}</span
                    >
                </div>

                <el-form ref="form" size="small" :model="form" :rules="rules" v-if='documentType==3'>
                    <el-form-item :label="$t('invoicesCenter.endpackDifreasonlabel')"  prop="difReason">
                        <el-input v-model="form.difReason" :placeholder="$t('invoicesCenter.endpackDifreasonplaceholder')"></el-input>
                    </el-form-item>
                </el-form>

<!--                <div v-if='documentType==3'>-->
<!--                <div>-->
<!--                    差异拣货的原因：-->
<!--                    <div><el-input v-model="difReason" placeholder="请输入差异拣货的原因"></el-input></div>-->
<!--                </div>-->
<!--            </div>-->
            </div>

            <div slot="footer">
                <el-button @click="dialogVisible = false">{{ $t('invoicesCenter.endpackCancelbtnV1') }}</el-button>
                <el-button type="primary" @click="submit">{{ $t('invoicesCenter.endpackConfirmbtnV1') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['modalParams', 'type','documentType'],

    data() {
        return {
            dialogVisible: false,
            form:{
                difReason:""
            },

            rules: {
                difReason: [{ required: true, message: this.$t('invoicesCenter.endpackDifreasonplaceholder'), trigger: 'blur' }]
            },
        }
    },
    created() {
        this.dialogVisible = true
    },
    methods: {
        close() {
            this.dialogVisible = false
            this.$emit('close')
        },
        submit() {
            if(!this.form.difReason&&this.documentType==3) {
                this.$message({
                    type: 'error',
                    message: this.$t('invoicesCenter.endpackDifreasonrequired'),
                    duration: 2000,
                    showClose: true
                })
                return
            }
            this.dialogVisible = false
            this.$emit('close', this.form.difReason,1)
        }
    }
}
</script>
<style scoped></style>
